import { dateInfo } from '../library'

export function buildTabLabelFromPath(pre, path) {
    return pre+replaceAll(path,'/','.');
}
/*
String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};
*/

function replaceAll(target, search, replacement) {
  return target.split(search).join(replacement);
}

export function convertToArray(series, array) {
  let serie;
  let rows;
  let values;
  let i, r, v;
  for (i=0;i<series.length;i++) {
    serie=series[i];

    rows=serie.rows;
    for (r=0; r<rows.length; r++) {
      values = rows[r].values;
      for (v=0;v<values.length; v++) {
        array[v][r+i+1]=values[v];
      }
    }
  }
}

export function addTimeSeries(series) {
  let res=[];
  let s,c, cols;
  for (s=0;s<series.length;s++) {
    cols = series[s].cols;
    for (c=0;c<cols.length;c++) {
      res[c]=[];
      res[c][0]=cols[c];
    }
  }
  return res;
}


export function convertMessage(cell, cellIdx, drillDownPath, intl, formatNumber=false) {
  let res = cell;
  if (formatNumber)
   res = intl.formatNumber(cell,{style:'decimal'})

  if (cellIdx===0) {
    res = intl.formatDate(cell, dateInfo[drillDownPath]);
  }

  return res;
}


export function getMessage(msg, keys, idx, intl) {

  var str = 'NoMsg';
    if (keys[idx].key)  {
      str =  keys[idx].key;
  } else {
    str = msg;
  }

  return intl.formatMessage({id:str});
}


export function checkQueryParams(type,operation,routerQueryParams, queryParams) {
  let errors=[];

  Object.keys(routerQueryParams).forEach(function(key) {
    try {
      if (!queryParams[key][routerQueryParams[key]]) {
        errors.push({error:"wrong query param: "+key+"="+routerQueryParams[key]});
      }
    } catch(err) {
      console.log("catch error");
      errors.push({error:"wrong query param: "+key+"="+routerQueryParams[key]});
    }
  });
  return errors;
}



// WEBPACK FOOTER //
// ./src/utils/index.js